<template>
  <svg class="close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M4 4L20 20M4 20L20 4" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
  </svg>
</template>
